import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
      programItemsSelected: [],
    programLists: [],
    programItems: [],
    modules: [],
    modulegroups: [],
    courses: [],
    selectedCourse: null,
    form: null,
    modalVisible: false,
    modalContent: null
  },
  mutations: {
    SET_PROGRAMLISTS (state, payload) {
      state.programLists = payload
    },
    SET_PROGRAMITEMS (state, payload) {
      state.programItems = payload
    },
    SET_MODULES (state, payload) {
      state.modules = payload
    },
    SET_MODULEGROUPS (state, payload) {
      state.modulegroups = payload
    },
    SET_COURSES (state, payload) {
      state.courses = payload
    },
    SET_SELECTED (state, payload) {
      let moduleIndex = state.form.modules.findIndex((module) => {
        return module.id === payload.id
      })
      if (moduleIndex > -1) {
        state.form.modules[moduleIndex].selected = payload.selected
      }
    },
    SET_FORM (state, payload) {
      state.form = payload
    },
    SET_SELECTED_COURSE (state, payload) {
      state.selectedCourse = payload
    },
    MODAL_VISIBLE (state, payload) {
      state.modalVisible = payload
    },
    MODAL_CONTENT (state, payload) {
      state.modalContent = payload
    }
  },
  getters: {
      programItemsSelected: state => {
      return state.programItemsSelected
    },
    programLists: state => {
      return state.programLists
    },
    programItems: state => {
      return state.programItems
    },
    modalVisible: state => {
      return state.modalVisible
    },
    modalContent: state => {
      return state.modalContent
    },
    modules: state => {
      return state.modules
    },
    selected: state => {
      let selected = state.form.allModules.filter((item) => {
        return item.selected
      })
      return selected
    },
    getCourseById: (state) => (id) => {
      return state.courses.find(course => course.id === id)
    },
    getCourseByName: (state) => (name) => {
      return state.courses.find(course => course.name === name)
    },
    getModuleById: (state) => (key) => {
      return state.modules.find(content => content.key === key)
    },
    getModuleGroupById: (state) => (key) => {
        return state.modulegroups.find(content => content.key === key)
    },
    isSelected: (state) => (key) => {
      return state.selected.indexOf(key) > -1
    },
    form: state => {
      return state.form
    },
    courses: state => {
      return state.courses
    },
    selectedCourse: state => {
      return state.selectedCourse
    }
  },
  actions: {
    setForm ({ commit }, payload) {
      commit('SET_FORM', payload)
    },
    setSelectedCourse ({ commit }, payload) {
      commit('SET_SELECTED_COURSE', payload)
    }
  }
})
